import { z } from "zod";



import { FormField } from "../../../FormEngine/types";





const ProvidersCredentialsList = [
  "Physician (MD, DO, etc.)",
  "Nurse Practitioner (NP)",
  "Physician Assistant (PA)",
  "Unknown",
];

/**
 * Provider History form schema
 *
 * This schema defines the fields for the Provider History form
 * using the FormEngine component.
 */
export const providerHistorySchema: FormField[] = [
  {
    type: "group-input",
    name: "primaryCareProvider",
    title: "Primary Care Provider",
    description: "Please list your primary care provider",
    group: [
      {
        type: "input",
        name: "primaryCareProvider.providerName",
        label: "Provider Name",
      },
      {
        type: "autocomplete",
        name: "primaryCareProvider.credentials",
        label: "Credentials",
        fieldProps: {
          allowCustom: true,
          options: ProvidersCredentialsList,
          disableMargins: true,
        },
      },
      {
        type: "input",
        name: "primaryCareProvider.practicingCity",
        label: "Practicing City",
      },
      {
        type: "date",
        name: "primaryCareProvider.careStartDate",
        label: "Care Start Date",
        fieldProps: {
          formatValue: "MM/DD/YYYY",
          disableFuture: true,
        },
      },
      {
        type: "date",
        name: "primaryCareProvider.careEndDate",
        label: "Care End Date",
        fieldProps: {
          formatValue: "MM/DD/YYYY",
          disableFuture: true,
        },
      },
    ],
    fieldProps: {
      direction: "column",
    },
  },
  {
    type: "group-input",
    name: "referringProvider",
    title: "Referring Provider",
    description: "Please list your referring provider, if applicable",
    fieldProps: {
      direction: "column",
    },
    group: [
      {
        type: "radio",
        name: "hasReferringProvider",
        label: "Do you have a referring provider?",
        fieldProps: {
          labelProps: {
            sx: {
              fontWeight: "bold",
            },
          },
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
          sx: { flexDirection: "row", gap: 1 },
        },
      },
      {
        type: "radio",
        name: "isSameAsPrimaryCare",
        label: "Same as Primary Care Provider?",
        fieldProps: {
          labelProps: {
            sx: {
              fontWeight: "bold",
            },
          },
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
          sx: { flexDirection: "row", gap: 1 },
        },
        conditional: {
          label: "hasReferringProvider",
          values: [true],
          resetOnHide: true,
        },
        rule: z.boolean(),
      },
      {
        type: "group-input",
        name: "referringProvider",
        group: [
          {
            type: "input",
            name: "referringProvider.providerName",
            label: "Provider Name",
          },
          {
            type: "select",
            name: "referringProvider.credentials",
            label: "Credentials",
            fieldProps: {
              options: ProvidersCredentialsList.map((cred) => ({ label: cred, value: cred })),
            },
          },
          {
            type: "input",
            name: "referringProvider.practicingCity",
            label: "Practicing City",
          },
          {
            type: "date",
            name: "referringProvider.careStartDate",
            label: "Care Start Date",
            fieldProps: {
              formatValue: "MM/DD/YYYY",
              disableFuture: true,
            },
          },
          {
            type: "date",
            name: "referringProvider.careEndDate",
            label: "Care End Date",
            fieldProps: {
              formatValue: "MM/DD/YYYY",
              disableFuture: true,
            },
          },
        ],
        conditional: {
          label: "isSameAsPrimaryCare",
          values: [false],
          resetOnHide: true,
        },
        fieldProps: {
          direction: "column",
        },
      },
    ],
  },
];

export default providerHistorySchema;